// extracted by css-extract-rspack-plugin
export default {"container":"LeadingContent-module__container__K_QfJ","isSelectable":"LeadingContent-module__isSelectable__GlBtD","centerAligned":"LeadingContent-module__centerAligned__yWt9h"};